import React from "react";
import { Link } from "gatsby";

function DesktopNav() {

  return (
    <nav
      className="hidden lg:block lg:flex lg:items-center lg:w-auto"
    >
      {[
        {
          route: `/about`,
          title: `About`,
        },
        {
          route: `/contact`,
          title: `Contact`,
        },
        {
          route: `/pricing`,
          title: `Pricing`,
        },
        {
          route: `/faq`,
          title: `FAQ`,
        },   
        {
          route: `/templates`,
          title: `Showcase`,
        },                
      ].map((link) => (
        <Link
          className="block font-semibold py-4 no-underline mx-auto md:mt-0 font-medium p-4
            text-gray-700 hover:text-gray-900 transition duration-150 ease-in-out focus:outline-none"
          key={link.title}
          to={link.route}
        >
          {link.title}
        </Link>
      ))}
      <Link
        className="block mt-4 no-underline md:inline-block md:mt-0 md:ml-8 px-6 py-2 
            rounded bg-indigo-600 text-white hover:bg-indigo-700 transition duration-150 ease-in-out focus:outline-none"
        to="/start"
      >
        Get started
      </Link>
    </nav>
  )
}

export default DesktopNav;